import { Suspense, lazy } from 'react';

import {
  BrowserRouter as Router,
  // Switch
} from 'react-router-dom';

import { ThemeProvider } from 'styled-components';
import { ToasterProvider } from '@success/domo-ds';

import { GlobalStyle, theme } from '@/styles';

import {
  AuthProvider,
  // ProtectedRoute,
  //  PublicOnlyRoute
} from '@/Auth';

import { useTranslate } from './hooks/useTranslate';

// const FormHomePage = lazy(() => import('@/pages/Form/Home'));
// const FormConstructorPage = lazy(() => import('@/pages/Form/Constructor'));
// const ErrorPage = lazy(() => import('@/pages/Error'));
// const WidgetHomePage = lazy(() => import('@/pages/Widget/Home'));
// const WidgetConstructorPage = lazy(() => import('@/pages/Widget/Constructor'));
const Routes = lazy(() => import('@/routes'));

export function App() {
  const { data } = useTranslate();

  return (
    <ThemeProvider theme={theme}>
      <ToasterProvider>
        <AuthProvider>
          {data ? (
            <Router>
              <Suspense fallback={<></>}>
                <Routes />
                {/* <Switch>
                  <ProtectedRoute path="/" exact>
                    <FormHomePage />
                  </ProtectedRoute>
                  <ProtectedRoute
                    path={['/constructor', '/constructor/:formId']}
                    exact
                  >
                      <FormConstructorPage />
                  </ProtectedRoute>
                  <ProtectedRoute path="/widget" exact>
                    <WidgetHomePage />
                  </ProtectedRoute>
                  <ProtectedRoute
                    path={[
                      '/widget/constructor',
                      '/widget/constructor/:widgetId',
                    ]}
                    exact
                  >
                    <WidgetConstructorPage />
                  </ProtectedRoute>
                  <PublicOnlyRoute path="/error" exact>
                    <ErrorPage />
                  </PublicOnlyRoute>
                </Switch> */}
              </Suspense>
            </Router>
          ) : (
            <></>
          )}
        </AuthProvider>
        <GlobalStyle />
      </ToasterProvider>
    </ThemeProvider>
  );
}
